<script setup lang="ts">
    import type { BackgroundColorsPredefined, IntroData } from '~/@types/cms';
    import type { ProductPreview } from '~/graphql/generated';

    interface ProductGridProps {
        products: Partial<ProductPreview>[];
        introCenter?: boolean;
        intro?: IntroData;
        background?: BackgroundColorsPredefined;
        colorFilter?: string;
    }
    const props = defineProps<ProductGridProps>();
    const productsToShow = filterProductColor(props.products, props.colorFilter);
</script>
<template>
    <mol-section
        class="org-product-grid"
        :intro="props.intro"
        :center="introCenter"
        :background="background">
        <template
            v-for="(product, idx) in productsToShow"
            :key="product.id">
            <mol-product-tile
                class="col-span-2 md:col-span-12 lg:col-span-6 xl:col-span-4"
                :product="product" />
        </template>
    </mol-section>
</template>
